<template>
  <!-- <div>
    <div>
      <input type="checkbox" @click="checkAll" v-model="checked" />
      <span>全选</span>
    </div>
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        style="margin-top: 20px"
      >
        <input type="checkbox" v-model="checkModel" :value="item.id" />
        <span>{{ item.name }}</span>　
      </li>
    </ul>
  </div> -->
  <div>
    <div
      class="management_tree_group"
      v-for="(group, index) in data"
      :key="index"
    >
      <label class="tree_group">
        <input
          type="checkbox"
          @click="checkAll(group, index)"
          v-model="checked"
        />
        <span>{{ group.name }}</span>
      </label>
      <img :src="row" alt="箭头" class="tree_row" />
      <div
        class="management_tree_item"
        v-for="(list, index) in group.account_list"
        :key="index"
      >
        <div class="tree_item">
          <label>
            <input
              type="checkbox"
              v-model="checkModel"
              :value="checkNum == list.id ? list.id : ''"
            />
            {{ checked }}
          </label>
          <img :src="list.avatar" alt="item.wx_name" />
          <span>{{ list.wx_name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      row: require("@/common/assets/right.png"),
      //   list: [
      //     { id: 1, name: "明明", age: 23, money: 100 },
      //     { id: 2, name: "红红", age: 18, money: 200 },
      //     { id: 3, name: "强强", age: 29, money: 300 },
      //   ],
      checked: false, //是否全选
      checked2: false,
      checkModel: [], //双向数据绑定的数组，我是用的id
      checkNum: -1,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    checkModel() {
      if (this.checkModel.length == this.list.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
  },
  methods: {
    checkAll(item, index) {
      this.checkNum = item.id;
      //   if (this.checked) {
      //     this.checkModel = [];
      //   } else {
      //     item.account_list.forEach((items) => {
      //       if (this.checkModel.indexOf(items.id) == -1) {
      //         this.checkModel.push(items.id);
      //       }
      //     });
      //   }
      if (this.checked) {
        item.account_list.forEach((items) => {
          items.checked = this.checked;
        });
      } else {
        item.account_list.forEach((items) => {
          items.checked = !this.checked;
        });
      }
      // console.log(this.checked);
    },
  },
};
</script>

<style lang="less">
.management_tree_group::after {
  content: "";
  clear: both;
  display: inline-block;
}
.management_tree_group {
  box-sizing: border-box;
  float: left;
  width: 94%;
  margin-left: calc(100% / 2 - 94% / 2);
}
.tree_group {
  position: relative;
  display: block;
  width: 90%;
  height: 55px;
  float: left;
  background-color: #fff;
  box-sizing: border-box;
  input {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-top: calc(55px / 2 - 20px / 2);
    float: left;
  }
  span {
    line-height: 55px;
    margin-left: 4px;
    font-size: 20px;
  }
}
.tree_row {
  float: right;
  width: 10px;
  height: 14px;
  margin-right: 10px;
  transform: rotate(90deg);
  margin-top: calc(55px / 2 - 14px / 2);
}
// list
.management_tree_item::after {
  content: "";
  display: inline-block;
  clear: both;
}
.management_tree_item {
  border: solid 1px #ccc;
  border-right: none;
  border-left: none;
  border-top: none;
  box-sizing: border-box;
  width: 94%;
  margin-left: calc(100% / 2 - 94% / 2);
  float: left;
  overflow: hidden;
  // height: auto;
}
.tree_item {
  float: left;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  // border: solid 1px blue;
  img {
    border: solid 1px #f0f0f0;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: inline-block;
    margin-top: calc(55px / 2 - 36px / 2);
    margin-left: 20px;
    float: left;
  }
  span {
    line-height: 55px;
    float: left;
    height: 55px;
    width: 180px;
    // border: solid 1px;
    margin-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  label {
    width: 20px;
    height: 20px;
    display: inline-block;
    float: left;
    margin-top: calc(55px / 2 - 32px / 2);
    margin-left: 34px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/groupManagement/CwTree.vue